export default (state, action) => {
  const { design, containers } = action.payload;

  const containerCount = {
    [design.designId]: state.containerCount[design.designId] || design.containers.length,
  };

  const itemCount = { ...state.itemCount };
  containers.forEach((c) => {
    if (!(c.containerId in itemCount)) {
      itemCount[c.containerId] = c.items.length;
    }
  });

  return {
    ...state,
    selectedEstimate: design.designId,
    containerCount,
    itemCount,
  };
};
